import React from 'react';
import { Hero } from './components/Hero';
import { Schedule } from './components/Schedule';
import { Rsvp } from './components/Rsvp';
import { Closing } from './components/Closing';
export function App() {
  return <div className="w-full bg-paper-100 font-sans" data-id="element-0" data-mp="3k8jjjl4ct8pp">
      <Hero data-id="element-1" data-mp="3k78bh93vless" />
      <main data-id="element-2" data-mp="3farf5rmivu4m">
        <Schedule data-id="element-3" data-mp="3f9ydh52f7utc" />
        <Rsvp data-id="element-4" data-mp="3fbj8swwk7hs9" />
      </main>
      <Closing data-id="element-5" data-mp="3fb9n3lijrwsd" />
    </div>;
}